// @ts-nocheck
// TODO: tighten types after migration
import storeClient from './storeApolloClient';
import { gql } from '@apollo/client';

export const fetchHygraphProduct = async (hygraphId) => {
    if (!hygraphId) {
        return null;
    }

    const query = gql`
        query Store {
            stores {
                id
                productName
                productSlug
                productDescription {
                    raw
                    html
                }
                productImages {
                    url
                }
            }
        }
    `;

    try {
        const { data } = await storeClient.query({ query });
        
        // Try to find by ID first, then by slug
        let product = (data && data.stores && data.stores.find(store => store.id === hygraphId));
        if (!product) {
            product = (data && data.stores && data.stores.find(store => store.productSlug === hygraphId));
        }
        return product || null;
    } catch (error) {
        console.error('Error fetching Hygraph data:', error);
        return null;
    }
};

